import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Greyfinch partner configuration schema
 *
 * Note: Greyfinch agents do not require configuration fields.
 * Authorization is handled by the backend `/on_connect` callback,
 * so no customer-provided configuration values or OAuth URL builder
 * are needed (config is null).
 */
export const greyfinchSchema: PartnerSchemaInternal = {
  partner: 'greyfinch' as PartnerEnum,
  displayName: 'Greyfinch',
  fields: [], // No configuration fields - backend handles setup
}
